import styled from 'styled-components';

export const Section = styled.div`
  flex: 1;
  min-height: 0;

  .items-scroll {
    flex: 1;
    min-height: 0;
  }

  .items-empty {
    max-width: 760px;
  }
`;
